var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdvantagesVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.91608 6C2.72996 6 1.75 6.93929 1.75 8.1204V16.6851C1.75 17.8662 2.72996 18.8055 3.91608 18.8055H13.5884C14.7745 18.8055 15.7545 17.8662 15.7545 16.6851V8.1204C15.7545 6.93929 14.7745 6 13.5884 6H3.91608ZM21.75 7.60696C21.75 7.45669 21.6673 7.31862 21.5348 7.24771C21.4023 7.1768 21.2415 7.18458 21.1165 7.26793L17.5194 9.66603C17.406 9.74161 17.3379 9.86883 17.3379 10.0051V14.8013C17.3379 14.9375 17.406 15.0647 17.5194 15.1403L21.1165 17.5384C21.2415 17.6218 21.4023 17.6295 21.5348 17.5586C21.6673 17.4877 21.75 17.3497 21.75 17.1994V7.60696Z",
    fill: "url(#paint0_linear_6314_84595)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6314_84595",
    x1: 11.75,
    y1: 6,
    x2: 11.75,
    y2: 18.8055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC92ED",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC92ED"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvantagesVideo);
export default __webpack_public_path__ + "static/media/advantages_video.082c67ba2afef1e5c6697a0a43242c1a.svg";
export { ForwardRef as ReactComponent };